import { makeStyles } from "@material-ui/core";

export const NewWashDashboardStyle = makeStyles((theme) => ({
    widgetWrapper: {
        backgroundColor: '#fff',
        borderRadius: '4px',
        boxShadow: 'none',
        height: '100%',
        padding: '1rem'
    },
    filtersWrapper: {
        display: 'flex',
        alignItems: 'center',
        padding: '1rem'
    },
    filterItem: {
        marginRight: '1rem',
    },
    filterItemLast: {
        marginRight: 0,
    },
    washFilterItem: {
        marginRight: '0.5rem',
        backgroundColor: '#ffffff'
    },
    graphTooltip: {
        background: 'white',
        padding: '0.5em 1em',
        borderRadius: '5px',
        boxShadow: '1px 2px 7px #ddd',
    },
    graphTooltipCustom: {
        maxWidth: '50vw',
        minWidth: 200,
        fontSize: '0.9em',
        padding: 8,
        background: '#fff',
        border: '1px solid #ccc',
        borderRadius: 6,
    },
    graphTooltipLabel: {
        fontWeight: 600,
        marginBottom: 4,
        fontSize: '1em',
        wordBreak: 'break-word',
    },
    graphTooltipNoWashes: {
        color: 'gray',
    },
    graphTooltipItemsWrapper: {
        display: 'grid',
        columnGap: '24px',
        rowGap: '4px',
    },
    graphTooltipTrendWrapper: {
        marginBottom: 8,
        borderBottom: '1px solid #ccc',
        paddingBottom: 8,
    },
    graphTooltipItemGrid: {
        display: 'grid',
        gridTemplateColumns: 'minmax(120px, auto) auto',
        alignItems: 'baseline',
    },
    graphTooltipItemName: {
        marginRight: '16px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'normal',
        wordBreak: 'break-word',
    },
    graphTooltipItemValue: {
        justifySelf: 'end',
    },
    graphTooltipItem: {
        fontSize: '0.9em',
    },
    legendLabel: {
        fontSize: '0.8em',
        color: 'black',
    },
    exportButtonWrapper: {
        display: 'flex',
        alignItems: 'flex-end',
    },
    tableOuterWrapper: {
        padding: '0.7rem',
    },
    tableRelativeWrapper: {
        width: '100%',
        position: 'relative',
    },
    tableScrollWrapper: {
        maxHeight: 300,
        overflowY: 'auto',
        overflowX: 'hidden',
        width: '100%',
    },
    exceptionTableIconWrapper: {
        padding: '1rem 0 0 0',
    },
    graphTooltip: {
        background: theme.palette.background.paper,
        padding: '0.1px 0.6em',
        border: '1px solid #eee',
        maxWidth: '9rem'
    },
    withinSlaColumn: {
        borderRadius: '20px',
        textAlign: 'center',
        fontSize: '1em',
        padding: '3px 15px',
        color: 'white',
        whiteSpace: 'nowrap',
        width: 'fit-content'
    },
    withinSla: {
        backgroundColor: '#b6ed7b'
    },
    aboveSla: {
        backgroundColor: '#db6f85'
    },
    excludedSla: {
        backgroundColor: '#cccccc',
    },
    washWidgetsBorder: {
        padding: '1em',
        boxShadow: 'none',
        margin: '1rem 0.5rem 1rem 0.5rem',
        borderRadius: '3px',
        backgroundColor: '#d7d6d673',
    },
    slaWidgetsWrapper: {
        backgroundColor: '#fff',
        border: '2px solid #d7d6d673',
        borderRadius: '4px',
        boxShadow: 'none',
        height: '100%',
        padding: '1rem'
    },
    selectWhite: {
        backgroundColor: theme.palette.background.paper,
        cursor: 'pointer',
        '& select': {
            border: 0,
            color: theme.palette.common.darkText,
            backgroundColor: theme.palette.background.paper,
            '&:focus': {
                backgroundColor: theme.palette.background.paper,
            },
        },
    },
    dateRange:{
        backgroundColor: theme.palette.background.paper,
    }
}));
